// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetOfferSuggestionsRequest,
  TGetOfferSuggestionsModel,
  IMappers,
  TGetOfferSuggestionsResponse,
  IGetOfferSuggestionsResponse,
  IGetOfferSuggestionsResponseError,
} from './types';

export const defaultConfig: TGetOfferSuggestionsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'cian-chat-bot',
  pathApi: '/v1/get-offer-suggestions/',
  requestType: 'json',
} as TGetOfferSuggestionsModel;

export function createGetOfferSuggestionsModel(parameters: IGetOfferSuggestionsRequest): TGetOfferSuggestionsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetOfferSuggestionsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOfferSuggestionsRequest;
}

export async function fetchGetOfferSuggestions<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOfferSuggestionsOptions<TResponse200, TResponse400>): Promise<
  TGetOfferSuggestionsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetOfferSuggestionsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetOfferSuggestionsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetOfferSuggestionsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetOfferSuggestionsResponse;
}
